<template>
  <div class="container">
    <h1 class="py-4">BANKIT-Choysanユーザサマリ</h1>
    <div>
      <div v-if="loading" class="form-row">
        <b-spinner
          class="autoMarginLR"
          variant="primary"
          label="Spinning"
        ></b-spinner>
      </div>
      <div v-if="!loading" class="table-responsive">
        <b-table
          id="dataTable"
          :items="tableData"
          :per-page="perPage"
          :current-page="currentPage"
          thead-class="hidden"
        >
          <template #cell(date)="data">
            <router-link
              :to="{
                name: 'UserRegistrationSummaryDetails',
                query: {
                  year: data.item.date.slice(0, 4),
                  month: data.item.date.slice(4, 6),
                },
              }"
              >{{ data.item.date.slice(0, 4) }}年{{
                data.item.date.slice(4, 6)
              }}月</router-link
            >
          </template>
        </b-table>
        <b-pagination
          class="mt30"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          align="right"
          aria-controls="dataTable"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import master from "@/constants/MasterEnum";
import utils from "@/utils/Utils";
import firebase from "firebase";

export default {
  name: "UserRegistrationSummary",
  mixins: [utils, master],
  computed: {
    rows() {
      return this.tableData.length;
    },
  },
  data() {
    return {
      db: firebase.firestore(),
      tableData: [],
      loading: true,
      currentPage: 1,
      perPage: 10,
    };
  },
  created: function() {
    this.loading = true;
    this.loadData();
  },
  methods: {
    async loadData() {
      const query = this.db
        .collection("batchUsersMonthList")
        .orderBy("year")
        .orderBy("month");
      const snapshot = await query.get();
      snapshot.forEach(async (doc) => {
        this.tableData.push({
          date: doc.id,
        });
      });
      this.loading = false;
    },
  },
};
</script>
